<template>
  <div class="order-container">
    <el-row class="cart-box">
      <el-col :span="24">
        <div class="nb">
          <!-- 购物车步骤 -->
          <div class="cart-step">
            <ul>
              <li class="cart1"><i></i>购物车</li>
              <li class="cart2 oncart2"><i></i>确认订单</li>
              <li class="cart3"><i></i>付款</li>
              <li class="cart4"><i></i>支付成功</li>
            </ul>
          </div>

          <!-- 收货人信息 -->
          <div class="add-deliver">
            <div class="cart-title">
              <h3><span>{{ $t('order.receiverInfo') }}</span></h3>
            </div>
            <div class="sh-address">
              <ul>
                <li class="add-add">
                  <div class="add-box add-box-center" @click="openAddressDialog">
                    <a href="javascript:void(0);">
                      <i class="icon-add-add"></i>
                      {{ $t('order.addNewAddress') }}
                    </a>
                  </div>
                </li>
                <li 
                  :class="calAddress(addr)" 
                  v-for="(addr, index) in userAddresses"  
                  @click="selectAddress(addr)"
                  :key="index"
                >
                  <div class="inner-infos">
                    <div class="addr-hd"><span>{{addr.areaName}}（{{addr.username}}）</span></div>
                    <div class="addr-bd"><span></span><span>{{addr.address}}{{addr.tel}}</span></div>
                    <a title="删除" style="color: brown;" @click.stop="deleteAddress(addr)">{{ $t('common.delete') }}</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- 商品信息 -->
          <div class="goods-infor">
            <div class="cart-title">
              <h3>
                <span>{{ $t('order.goodsInfo') }}</span>
                <a v-if="nowBuyProductId == ''" href="/pageLR.html#/pages/plateform/cart" class="vivi-blue">{{ $t('order.backToCart') }}</a>
              </h3>
            </div>
            <div class="goods-table">
              <div class="goods-thead">
                <div class="col col1">{{ $t('order.goods') }}</div>
                <div class="col col3">{{ $t('order.price') }}</div>
                <div class="col col4">{{ $t('order.quantity') }}</div>
                <div class="col col5">{{ $t('order.subtotal') }}</div>
              </div>
              <div class="goods-tbody">
                <div class="goodinfor" v-for="(prod, index) in orderInfo.prods" :key="index">
                  <div class="col col1 goods-title-pic">
                    <a :href="'/page.html#/pages/plateform/productDetail?productId=' + prod.productId">
                      <img :src="prod.coverPhoto" width="60" height="60">
                    </a>
                    <div class="goods-describ elli">
                      <p>
                        <a :href="'/page.html#/pages/plateform/productDetail?productId=' + prod.productId">{{prod.prodName}}</a>
                      </p>
                    </div>
                  </div>
                  <div class="col col3 goods-price"> ￥{{prod.ownerPrice}} </div>
                  <div class="col col4 good-num"> {{prod.goodsNum}} </div>
                  <div class="col col5 orange-bold xiaoji"> ￥{{prod.goodsNum * prod.ownerPrice}} </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 支付方式 -->
          <div class="style-zhifu">
            <div class="cart-title">
              <h3><span>{{ $t('order.paymentMethod') }}</span>（{{ $t('order.paymentNote') }}）</h3>
            </div>
            <div class="zhifu-box">
              <ul class="zfb">
                <li>
                  <i class="icon-check-zf" style="display: block;"></i>
                  <a href="javascript:void(0);" class="selected">
                    <img src="/img/wxpay_native.png">{{ $t('order.wechatPay') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- 配送方式 -->
          <div class="style-zhifu">
            <div class="cart-title">
              <h3><span>{{ $t('order.deliveryMethod') }}</span></h3>
            </div>
            <div class="zhifu-box">
              <ul class="zfb">
                <li>
                  <i class="icon-check-zf" style="display: block;"></i>
                  <a href="javascript:void(0);" class="selected">{{ $t('order.defaultDelivery') }}</a>
                </li>
              </ul>
            </div>
          </div>

          <!-- 结算信息 -->
          <div class="fare-result">
            <div class="cart-title">
              <h3><span>{{ $t('order.settlementInfo') }}</span></h3>
            </div>
            <div class="result-box">
              <ul>
                <li class="first">
                  <div class="calu-box">
                    <p class="slivergrey">
                      <span>
                        <b class="orange-bold">{{orderInfo.totalNum}}</b> 
                        {{ $t('order.goodsTotal') }}：
                      </span>
                      <span class="txtmoney">￥<b>{{orderInfo.totalMount}}</b></span>
                    </p>
                    <p class="slivergrey">
                      <span>{{ $t('order.shippingFee') }}：</span>
                      <span class="txtmoney">￥<b>0.00</b></span>
                    </p>
                  </div>
                </li>
                <li>
                  <div class="lside">
                    <p class="save-passw">
                      <span class="slivergrey">{{ $t('order.paymentPassword') }}：</span>
                      <el-input type="password" v-model="paymentPassword"></el-input>
                    </p>
                  </div>
                  <div class="rside">
                    <div class="lside">
                      <p>
                        <span class="slivergrey">{{ $t('order.payableAmount') }}：</span>
                        <span class="orange-bold big">￥<b>{{orderInfo.totalMount}}</b></span>
                      </p>
                    </div>
                    <el-button type="primary" class="btn-jiesuan" @click="_createOrder(orderInfo.shopId)">
                      {{ $t('order.submitOrder') }}
                    </el-button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 地址对话框组件 -->
    <address-dialog ref="addressDialog" @refresh="listAddresses"></address-dialog>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { computeOrderPrice, createOrder, listAddresses,deleteAddress } from '@/api/plateform/order/orderApi'
import AddressDialog from '@/components/plateform/order/AddressDialog.vue'

export default {
  name: 'Order',
  components: {
    AddressDialog
  },
  data() {
    return {
      orderInfo: {
        prods: [],
        total: 0,
        shopId: '',
        records: 1,
        moreCondition: false,
        totalMount: 0.00,
        totalNum: 0,
        conditions: {}
      },
      userAddresses: [],
      nowBuyProductId: '',
      paymentPassword: '',
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.listAddresses()
    this.computeStoreOrderPrice()
    console.log(this.nowBuyProductId)
  },
  methods: {
    async listAddresses() {
      try {
        const res = await listAddresses({
          page: 1,
          row: 100,
          userId: this.$store.getters.userId
        })
        this.userAddresses = res.data
      } catch (error) {
        console.error('获取地址列表失败:', error)
      }
    },
    async computeStoreOrderPrice() {
      try {
        const res = await computeOrderPrice({
          page: 1,
          row: 100,
          shopId: this.$route.query.shopId,
          cartType: '3306',
          productId: this.$route.query.productId,
          valueId: this.$route.query.valueId,
          goodsNum: this.$route.query.goodsNum,
          killId: this.$route.query.killId
        })
        this.orderInfo.prods = res.data.goods
        this.orderInfo.shopId = this.$route.query.shopId
        this.calculateTotal()
      } catch (error) {
        console.error('计算订单价格失败:', error)
      }
    },
    calculateTotal() {
      let totalAmount = 0
      let totalNum = 0
      this.orderInfo.prods.forEach(item => {
        if (!isNaN(item.goodsNum) && !isNaN(item.ownerPrice)) {
          totalAmount += parseFloat(item.goodsNum) * parseFloat(item.ownerPrice)
          totalNum += parseFloat(item.goodsNum)
        }
      })
      this.orderInfo.totalMount = totalAmount.toFixed(2)
      this.orderInfo.totalNum = totalNum
    },
    calAddress(addr) {
      return addr.isDefault == "1" ? "default-add" : "other-add"
    },
    selectAddress(addr) {
      this.userAddresses.forEach(item => {
        item.isDefault = "0"
      })
      addr.isDefault = "1"
    },
    async deleteAddress(addr) {
      try {
        await this.$confirm(this.$t('order.confirmDeleteAddress'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
        await deleteAddress(addr)
        this.$message.success(this.$t('order.deleteSuccess'))
        this.listAddresses()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除地址失败:', error)
        }
      }
    },
    async _createOrder(shopId) {
      if (!this.validateOrder()) return

      try {
        const res = await createOrder({
          products: this.orderInfo.prods,
          addressId: this.getDefaultAddressId(),
          payType: "1001",
          deliveryType: "1001",
          shopId: shopId
        })
        this.$message.success(this.$t('order.orderCreated'))
        this.$router.push(`/pages/plateform/pay?orderId=${res.data.orderId}`)
      } catch (error) {
        console.error('创建订单失败:', error)
      }
    },
    validateOrder() {
      if (!this.getDefaultAddressId()) {
        this.$message.warning(this.$t('order.selectAddress'))
        return false
      }
      if (this.orderInfo.prods.length === 0) {
        this.$message.warning(this.$t('order.selectGoods'))
        return false
      }
      return true
    },
    getDefaultAddressId() {
      const defaultAddr = this.userAddresses.find(item => item.isDefault == "1")
      return defaultAddr ? defaultAddr.addressId : null
    },
    openAddressDialog() {
      this.$refs.addressDialog.open()
    }
  }
}
</script>

<style scoped>
.cart-box {
  width: 100%;
}
.nb {
  padding: 20px;
}
.cart-step ul {
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0 0 20px 0;
  list-style: none;
}
.cart-step li {
  position: relative;
  padding: 0 20px;
  text-align: center;
}
</style>